export interface IBindingRule {
    constraintId: string;
    action: BindingType;
}

export enum BindingType {
    Visibility = 0,
    Enabled = 1,
    Calculation = 2,
    Label = 3,
    Tooltip = 4,
    VisibilityOrEmpty = 5,
}

export enum EArrayFuncion {
    APPLY_MAP = 'APPLY_MAP',
    APPLY_FIND = 'APPLY_FIND',
    APPLY_FIND_INDEX = 'APPLY_FIND_INDEX',
    APPLY_FIND_DEEP = 'APPLY_FIND_DEEP',
    APPLY_FIND_INDEX_DEEP = 'APPLY_FIND_INDEX_DEEP',
    APPLY_FILTER = 'APPLY_FILTER',
    APPLY_PIVOT_FILTER = 'APPLY_PIVOT_FILTER',
    APPLY_PIVOT_MULTI_FILTER = 'APPLY_PIVOT_MULTI_FILTER',
    ARRAY_CLONE_DEEP = 'ARRAY_CLONE_DEEP',
    ARRAY_JOIN = 'ARRAY_JOIN',
}

export enum EDateFuncion {
    MOMENT = 'MOMENT',
    TO_ISO_STRING = 'TO_ISO_STRING',
    SE_TODAY = 'SE_TODAY',
}

export enum ECustomFunction {
    EXPORTCLINICALEVAL = 'EXPORTCLINICALEVAL',
    EXPORT_SEGMENTAL_KINETIC = 'EXPORT_SEGMENTAL_KINETIC',
    AUTOMATIC_SET_KINETIC_COMBO = 'AUTOMATIC_SET_KINETIC_COMBO',
    EXPORT_VASSEL_REPORT = 'EXPORT_VASSEL_REPORT',
}
